import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Alert, Row, Col } from 'reactstrap';
import moment from 'moment';
import photoNotFound from '../../../../assets/img/photo_not_found.png'

const propTypes = {
    id: PropTypes.number,
    id_do: PropTypes.string,
    wo_number: PropTypes.string,
    wo_desc: PropTypes.wo_desc,
    desc: PropTypes.string,
    main_customer: PropTypes.string,
    loc_name: PropTypes.string,
    id_request: PropTypes.number,
    eta: PropTypes.string,
    rta: PropTypes.string,
    reg_number: PropTypes.string,
    driver_name: PropTypes.string,
    driver_photo: PropTypes.string,
    origin_company: PropTypes.string,
    transporter_company: PropTypes.string
}

const defaultProps = {
    id: 0,
    id_do: 0,
    wo_number: 'ABC123',
    wo_desc: '',
    id_request: null,
    loc_name: '',
    main_customer: 'Automa',
    eta: '31 Dec 2021 10:00:00',
    rta: '31 Dec 2021 10:00:00',
    reg_number: 'B 1234 ABC',
    driver_name: 'Soegianto',
    driver_photo: '',
    origin_company: 'Sentra Solusi Automa, PT.',
    transporter_company: 'Sentra Solusi Automa, PT.',
}

class DeliveryConfirmationDetails extends Component {
    constructor(props) {
        super(props);
        this.state = { 

        };
    }

    showContent = () => {
        const { wo_number, wo_desc, main_customer, eta, rta, loc_name, id_request, origin_company, transporter_company } = this.props;
        const { driver_name, driver_photo, driver_asst_name, driver_asst_photo } = this.props;
        return (
            <div>
                <Row className="container">
                    <Col md="6">
                        <h5>Informasi Pengiriman</h5>
                        <dt>NO. WO</dt>
                        <dd>{wo_number ? wo_number : '-'}</dd>

                        <dt>Deskripsi</dt>
                        <dd style={{ textAlign: 'justify' }}>{wo_desc ? wo_desc : '-'}</dd>

                        <dt>Nama Customer</dt>
                        <dd>{main_customer ? main_customer : '-'}</dd>

                        <dt>Perkiraan waktu tiba</dt>
                        <dd>{ eta ? moment(eta).format('dddd, DD MMM YYYY HH:mm:ss') : '-' }</dd>

                        <dt>Waktu tiba</dt>
                        <dd>{ rta ? moment(rta).format('dddd, DD MMM YYYY HH:mm:ss') : '-' }</dd>

                        {/* <dt>WO Address</dt>
                        <dd style={{ textAlign: 'justify' }}>{data.result[0].work_order_from.wo_address ? data.result[0].work_order_from.wo_address : '-'}</dd> */}
                    </Col>
                    <Col md="6">
                        <h5>Informasi Perusahaan</h5>

                        <dt>Perusahaan Asal</dt>
                        <dd>{id_request === null ? transporter_company : (origin_company ? origin_company : '-')}</dd>
                        
                        <dt>Perusahaan Pengirim</dt>
                        <dd>{transporter_company ? transporter_company : '-'}</dd><br/><br/>

                        <h5>Titik Pengiriman</h5>

                        <dt>Titik Pengiriman</dt>
                        <dd>{loc_name ? loc_name : '-'}</dd>
                        {/* <h6>Time-related Information</h6>
                        <dt>Distance</dt>
                        <dd>{data.result[0].work_order_from.distance ? data.result[0].work_order_from.distance + ' KM' : '-'}</dd>

                        <dt>Est. Departure Time</dt>
                        <dd>{data.result[0].work_order_from.est_departure_time ? this.dateFormatter(data.result[0].work_order_from.est_departure_time) : '-'}</dd>

                        <dt>Est. Arrival Time</dt>
                        <dd>{data.result[0].work_order_from.est_arrival_time ? this.dateFormatter(data.result[0].work_order_from.est_arrival_time) : '-'}</dd>

                        <dt>Check-in Time</dt>
                        <dd>{data.result[0].work_order_from.timeCheckIn ? this.dateFormatter(data.result[0].work_order_from.timeCheckIn) : '-'}</dd>

                        <dt>Check-out Time</dt>
                        <dd>{data.result[0].work_order_from.timeCheckOut ? this.dateFormatter(data.result[0].work_order_from.timeCheckOut) : '-'}</dd> */}
                    </Col>
                    <Col md="12">
                        <br/>
                        <h5>Informasi Lainnya</h5>             
                        <Row md="12">
                            <Col md="6"> 
                                <img width="60" height="70"  src={driver_photo ? encodeURI(driver_photo) : photoNotFound}  alt="driver"/> 
                                <div style={{ marginLeft: "5px", display: "inline-block"}}> 
                                    <dt><strong>Nama Supir</strong></dt><dd>{driver_name}</dd>
                                </div>
                            </Col>
                            <Col md="6"> 
                                <img width="60" height="70" src={driver_asst_photo ? encodeURI(driver_asst_photo) : photoNotFound}  alt="asst. driver"/> 
                                <div style={{ marginLeft: "5px", display: "inline-block"}}> 
                                    <dt><strong>Nama Asst. Supir</strong></dt><dd>{driver_asst_name}</dd>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                
            </div>
        )
    }

    render() {
        return (
            <div>
                <Alert color="warning">
                    Anda akan melakukan konfirmasi penerimaan barang yang telah dikirim. Hal ini mempermudah kami untuk melakukan pengecekan penerimaan barang serta meningkatkan layanan kami kedepannya. <br/>
                    <strong>Silahkan isi formulir berikut!</strong>
                    {/* You are about to confirm your delivery. This helps us easier to track our logistics services and ensure you that you got the right package. <br/>
                    <strong>Please check the details below!</strong> */}
                </Alert>
                {this.showContent()}
            </div>
        );
    }
}

DeliveryConfirmationDetails.propTypes = propTypes;
DeliveryConfirmationDetails.defaultProps = defaultProps;

export default DeliveryConfirmationDetails;


// WEBPACK FOOTER //
// ./src/views/Transporter/DeliveryConfirmation/ID-id/DeliveryConfirmationDetails.jsx